const typography = {
  fonts: {
    body: "'Open Sans',Helvetica,Arial,sans-serif",
    heading: "'Open Sans',Helvetica,Arial,sans-serif",
    monospace: "Menlo, monospace"
  },
  fontSizes: {
    "-2": "0.75rem",
    "-1": "0.875rem",
    "0": "1rem",
    "1": "1.125rem",
    "2": "1.25rem",
    "3": "1.75rem",
    "4": "2.25rem",
    "5": "3rem"
  },
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700
  },
  lineHeights: [1, 1.1, 1.25, 1.5],
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  }
};
export default typography;

export const heading = {
  fontFamily: "heading",
  lineHeight: "heading",
  fontWeight: "heading"
};
